<template>
  <v-main style="margin: 10px">
    <v-data-table :headers="headers" :items="agentList" :items-per-page="15" :search="keyword">
      <template v-slot:top>
        <v-row no-gutters style="padding: 20px 10px 0px">
          <v-col cols="12" sm="6">
            <div class="d-flex px-2">
              <h2 v-if="$store.state.principal.role != 'bdm'">Agent info</h2>
              <h2 v-else>My duo agents</h2>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <div class="d-flex px-2">
              <v-text-field v-model="keyword" append-icon="mdi-magnify" label="Search" hide-details
                style="margin-right: 10px"></v-text-field>
              <v-btn v-if="$store.state.principal.role == 'super_user' || $store.state.principal.role == 'bdm'" small fab dark color="secondary" title="Add" @click="addDialog = true">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <v-btn medium color="red darken-1" @click="onDeletePendingAgent" class="white--text mx-0"><v-icon
                  left>mdi-delete</v-icon>
                Delete All Pending Agents
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-inline-flex justify-end align-center pt-0" cols="12">
            <div class="px-2">
              <div class="filter-label">State</div>
              <v-autocomplete dense solo v-model="state" :items="stateFilter" label="State"
                append-icon="mdi-chevron-down" />
            </div>
            <div class="px-2">
              <v-btn medium color="primary" @click="getCSVAgentByState" style="text-transform: none;"><v-icon
                  left>mdi-export</v-icon> Export Agent Info Report</v-btn>
              <v-btn v-if="$store.state.principal.role != 'super_user'" medium color="primary" @click="getCSVAgent"
                style="text-transform: none;"><v-icon left>mdi-export</v-icon> Export Managed Agent Info Report</v-btn>
            </div>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.name="{ item }">{{
        item.firstName + " " + item.lastName
      }}</template>

      <template v-slot:item.tag="props">
        <v-edit-dialog :return-value.sync="props.item.transitMap.tag" large persistent @save="saveTag(props.item.id)"
          @cancel="cancel" @open="open(props.item)" @close="close">
          <v-row class="text-center my-1">
            <div class="state-badge py-1 px-3 secondary text-no-wrap rounded-pill"
              v-for="tag of props.item.transitMap.tag" :key="tag">
              {{ tag }}
            </div>
            <v-icon>mdi-plus-circle-multiple-outline</v-icon>
          </v-row>
          <template v-slot:input>
            <div style="min-width: 400px">
              <div class="mt-4 mb-2 text-h6">Update Tag</div>
              <div class="d-inline-flex" style="width: 100%" v-for="(inputTag, indexTag) in tagList" :key="indexTag">
                <v-btn @click="removeTag(indexTag)" color="red" icon dark>
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-text-field v-model="tagList[indexTag]" :rules="[(v) => v || 'This field is required']" label="Tag"
                  style="margin-right: 10px" outlined></v-text-field>
                <v-btn @click="removeTag(indexTag)" color="red" icon dark>
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
              <div>
                <v-btn @click="addTag()" color="primary darken-1" small :disabled="!tagList[tagList.length - 1] != ''">Add
                  Tag</v-btn>
              </div>
            </div>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-end pr-4">
          
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon class="mr-2" v-on="{ ...tooltip }" v-if="$store.state.principal.role == 'super_user' && item.status == 'Pending'" @click="resendEmail(item)">mdi-email</v-icon>
            </template>
            <span>Resend Activation Email</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon class="mr-2" v-on="{ ...tooltip }" v-if="$store.state.principal.role == 'super_user' && item.status != 'Pending'" @click="showImpersonateDialog(item)
                ">mdi-login-variant</v-icon>
            </template>
            <span>Impersonate</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon class="mr-2" v-on="{ ...tooltip }" v-if="$store.state.principal.role == 'super_user' && item.status != 'Pending'" @click="onConfirmChange(item)
                ">{{ item.status == 'Active' ? 'mdi-cancel' : 'mdi-check-circle-outline' }}</v-icon>
            </template>
            <span>{{ item.status == 'Active' ? 'Deactivate Agent' : 'Activate Agent' }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-icon class="mr-2" v-on="{ ...tooltip }" @click="$router.push(`/administration/agent/info/${item.id}/details`)
              ">mdi-account-group-outline</v-icon>
            </template>
            <span>Agent Info</span>
          </v-tooltip>  
          
        </div>
      </template>
    </v-data-table>
    <confirmation-dialog :title="confirmationDialog.title" :show="confirmationDialog.show"
      :content="confirmationDialog.content" @onCloseDialog="confirmationDialog.show = false" @onClickConfirm="changeStatus" />
    <dialog-impersonate :show="dialogImpersonate.show" :user="dialogImpersonate.item"
      @onCloseDialog="dialogImpersonate.show = false" />

    <v-snackbar
			v-model="snackbar"
			:timeout="800"
			color="success"
			variant="outlined"
		>
			Email sent
		</v-snackbar>

    <v-snackbar
			v-model="snackbarDelete"
			:timeout="1000"
			color="success"
			variant="outlined"
		>
			<div style="width: 100%; text-align: center;">
        All pending agents have been deleted
      </div>
		</v-snackbar>

    <v-dialog v-model="addDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Add An Agent</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" style="padding: 0 40px" v-model="valid" autocomplete="off">

            <!-- firstname -->
							<v-text-field id="firstName" v-model="firstName" :rules="[ruleName]" :class="{ 'line-blue': firstName != null && firstName.length > 0 }">
								<template v-slot:label>
									<span class="duo">First name*</span>
								</template>
							</v-text-field>
							<!-- firstname end -->

              <!-- lastname -->
							<v-text-field id="lastName" v-model="lastName" :rules="[ruleName]" :class="{ 'line-blue': lastName != null && lastName.length > 0 }">
								<template v-slot:label>
									<span class="duo">Last name*</span>
								</template>
							</v-text-field>
							<!-- lastname end -->

              <!-- Email -->
							<v-text-field
								id="email"
								v-model="email"
								type="email"
								persistent-hint
								validate-on-blur
								:hint="errormail.show === false ? errormail.hint : ''"
								:rules="[ruleEmail]"
								:loading="emailFetching"
								:class="{ 'line-blue': !errormail.show && email != null && email.length > 0 }"
							>
								<template v-slot:label>
									<span class="duo">Work email*</span>
								</template></v-text-field
							>
							<v-card
								class="pa-2 white--text"
								v-if="emailHint.length > 0"
								style="font-size: 12px; color: rgba(0, 0, 0, 0.75); margin: 10px 0; background-color: rgb(11, 187, 239) !important; border-color: rgb(11, 187, 239) !important"
								color="blue lighten-3"
								v-html="emailHint"
							></v-card>
							<!-- Email end -->

              <!-- Mobile Number -->
							<v-text-field
								id="mobileNumber"
								v-model="mobileNumber"
								persistent-hint
								hide-details="true"
								type="number"
								:loading="mobileNumberFetching"
								:class="{ 'line-blue': !errormobile.show && mobileNumber != null && mobileNumber.length > 0 }"
							>
								<template v-slot:label>
									<span class="duo">Mobile number</span>
								</template>
							</v-text-field>
							<v-card
								class="pa-2 white--text"
								v-if="mobileNumberHint.length > 0"
								style="font-size: 12px; color: rgba(0, 0, 0, 0.75); margin: 10px 0; background-color: rgb(11, 187, 239) !important; border-color: rgb(11, 187, 239) !important"
								color="blue lighten-3"
								v-html="mobileNumberHint"
							></v-card>
							<!-- Mobile Number end -->

              <!-- PCC Code -->
							<v-text-field
                style="padding-top: 20px;"
								id="agencyCode"
								class="agencyCode"
								v-model="agencyCode"
								persistent-hint
								hint="Agency Pseudo Code (PCC) is an alphanumeric identifier for a travel agency using the global distribution system (GDS). A valid PCC must be a combination of three, four, six or nine numbers and characters."
								:rules="[ruleAgencyCode, agencyCodeMatch]"
								maxlength="9"
								:loading="agencyCodeFetching"
								:class="{ 'line-blue': agencyCode != null && agencyCode.length > 0 && agencyCodeMatch }"
								:error="agencyCodeHint.length > 0 && !agencyCodeMatch"
								:error-messages="agencyCodeHint.length > 0 && !agencyCodeMatch ? 'Sorry, we do not have your PCC. Please email duosupport@airnz.co.nz and we will get you set up.' : ''"
							>
								<template v-slot:label>
									<span class="duo">Agency Pseudo Code (PCC)*</span>
								</template>
							</v-text-field>
							<!-- PCC Code end -->

              <!-- Password -->
							<v-text-field
								id="password"
								v-model="password"
								persistent-hint
								:rules="[  v => !!v || 'Enter a strong password', v => /^(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/.test(v) || 'Your password must be STRONG']"
								:append-icon="passwordType ? 'mdi-eye' : 'mdi-eye-off'"
								@click:append="() => (passwordType = !passwordType)"
								:type="passwordType ? 'password' : 'text'"
								:class="{ 'line-blue': password != '' && password.length > 0 }"
							>
								<template v-slot:label>
									<span class="duo">Password*</span>
								</template>
								<template v-slot:message>
									<span>Your password must be <b>STRONG</b></span>
									<ul>
										<li>Passwords must have at least one non-alphanumeric character (e.g. ! @ # or a space)</li>
										<li>Passwords must have at least one digit ('0'-'9')</li>
										<li>Passwords must have at least one uppercase letter ('A'-'Z')</li>
										<li>Minimum 8 characters</li>
									</ul>
								</template>
							</v-text-field>
							<v-row v-if="password.length > 0" no-gutters justify="center">
								<p style="font-size: 13px !important; font-family: 'AirNZ Sans Regular' !important">Password strength</p>
								&nbsp;
								<p style="font-size: 13px !important; font-family: 'AirNZ Sans Semibold' !important">{{ passwordStrength.message }} password</p>
							</v-row>

							<v-text-field
								id="confirmPassword"
								v-model="confirmPassword"
                :rules="[(v) => !!v || 'Please confirm your password', (v) => (v && v === password) || 'Password does not match']"
								:append-icon="confirmPasswordType ? 'mdi-eye' : 'mdi-eye-off'"
								@click:append="() => (confirmPasswordType = !confirmPasswordType)"
								:type="confirmPasswordType ? 'password' : 'text'"
								:class="{ 'line-blue': confirmPassword != null && confirmPassword.length > 0 }"
							>
								<template v-slot:label>
									<span class="duo">Confirm password*</span>
								</template>
							</v-text-field>
							<!-- Password end -->
              
            <!-- Street, Road etc. end -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn @click="save" color="primary">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent max-width="500px" v-model="showAgentPendingDialog">
        <v-card>
            <v-card-title>
                <span class="headline"> Delete Pending Agents</span>
            </v-card-title>
            <v-card-text class="content">Confirm to delete all pending agents ?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="showAgentPendingDialog = false">Cancel</v-btn>
                <v-btn @click="deletePendingAgents" color="primary">Confirm</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

  </v-main>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import axios from "axios";
import confirmationDialog from "./dialog/confirmationDialog.vue";
import dialogImpersonate from "./dialog/dialogImpersonate.vue";

export default {
  components: {
    confirmationDialog,
    dialogImpersonate,
  },
  data: function () {
    return {
      agencyCodeBannedList: [],
      passwordType: true,
			confirmPassword: null,
			confirmPasswordType: true,
      password: "",
      agencyCodeMatch: false,
      agencyCode: null,
			agencyCodeValid: false,
			agencyCodeFetching: false,
			agencyCodeHint: "",
      mobileNumber: null,
			mobileNumberFetching: false,
			mobileNumberHint: "",
      errormobile: {
				show: false,
				content: "",
				hint: "We will only contact you about your <strong>duo</strong> account activity and the progress of rewards.",
			},
      emailHint: "",
      emailFetching: false,
      firstName: null,
			lastName: null,
			email: null,
      valid: true,
      errormail: { show: false, content: "", hint: "" },
      addDialog: false,
      snackbar: false,
      snackbarDelete: false,
      agencyGroupId: 0,
      keyword: "",
      headers: [
        { text: "Name", value: "name" },
        { text: "Account Name", value: "agencyName" },
        { text: "Account Manager", value: "bdmAdminName" },
        { text: "State", value: "agencyState", filter: f => { return (f + '').toLowerCase().includes(this['state'].toLowerCase()) } },
        { text: "Suburb", value: "agencySuburb" },
        { text: "Postcode", value: "agencyPostCode" },
        { text: "Email", value: "email" },
        //{ text: "Store", value: "storeBranch" },
        { text: "Agency Code", value: "agencyCode" },
        { text: "Status", value: "status" },
        { text: "Tag", value: "tag" },
        { text: "", value: "action", sortable: false },
      ],
      agentList: [],
      agent: { map: {} },
      entity: {
        map: {},
      },
      tagList: [],
      confirmationDialog: {
        show: false,
        item: {},
        title: '',
        content: ''
      },
      dialogImpersonate: {
        show: false,
        item: {},
      },
      state: "",
      stateFilter: [''],
      showAgentPendingDialog: false,
    };
  },
  mounted: function () {
    this.getList();

    this.stateFilter = this.$store.state.principal.role != 'bdm' ? ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'] : this.$store.state.principal.states;
    this.stateFilter.unshift('');

    this.listBannedAgencyCode();
  },
  computed: {
		passwordStrength() {
			let data = {
				message: "Weak",
				isVeryWeak: false,
				isWeak: false,
				isFair: false,
				isStrong: false,
			};
			const regex = /^(?=.*\d)(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/g;
			let isSpecial = this.password.match(regex);
			data.isWeak = this.password.length >= 1 && this.password.length < 8 ? true : data.isWeak;

			data.message = data.isWeak ? "Weak" : data.message;
			data.isStrong = isSpecial && this.password.length >= 8 ? true : data.isStrong;
			data.message = data.isStrong ? "Strong" : data.message;

			return data;
		},
	},
  methods: {
    listBannedAgencyCode() {
			axios
				.get("/system/administration/agency/code/banned/list")
				.then((response) => {
					this.agencyCodeBannedList = response.data;
				})
				.catch(() => {});
		},
    findAgency(v) {
			// form is being validated, do not call back-end
			if (this.registering) {
				this.registering = false;
				return;
			}
			this.agencyCodeHint = "";
			if (!v) {
				return;
			}
			if ((v.length == 3 || v.length == 4 || v.length == 6 || v.length == 9) && v.match(/^[a-z0-9]+$/i)) {
				if (this.agencyCodeBannedList.includes(v)) {
					return;
				}
			} else {
				return;
			}
			this.agencyCodeFetching = true;
			axios
				.post("/system/agency/find", {
					code: v,
				})
				.then((response) => {
					// have we ever fetched ever?
					this.agencyCodeFetched = true;
					let data = response.data;

					if (data === "Invalid") {
            //
					} else if (data === "Banned") {
            //
          } else if (data && data.id) {
						this.agencyId = data.id;
						this.agencyGroupId = data.agencyGroupId;
						this.agencyName = data.name;

						this.unitAgencyAddress = data.unit;
						this.streetAgencyAddress = data.street;
						this.suburbAgencyAddress = data.suburb;
						this.stateAgencyAddress = data.state;
						this.postCodeAgencyAddress = data.postCode;

						if (this.suburbAgencyAddress == "" || this.streetAgencyAddress == "" || this.postCodeAgencyAddress == "") {
							this.manualEditAddress = true;
						}

						this.agencyCodeMatch = true;
						this.agencyCodeHint =
							"We have successfully matched your PCC in our system and updated your agency details below. Please check the details are correct. All fields highlighted grey cannot be amended, please contact duosupport@airnz.co.nz if they are incorrect.";
						this.checkFreeAgent();
					} else {
						this.agencyGroupId = null;
						this.agencyName = null;

						this.unitAgencyAddress = null;
						this.streetAgencyAddress = null;
						this.suburbAgencyAddress = null;
						this.stateAgencyAddress = null;
						this.postCodeAgencyAddress = null;

						this.agencyCodeMatch = false;
						this.agencyCodeHint = "Sorry, we do not have your PCC. Please email duosupport@airnz.co.nz and we will get you set up.";

						this.checkFreeAgent();
					}
				})
				.catch(() => {})
				.finally(() => {
					this.agencyCodeFetching = false;
				});
		},
    ruleAgencyCode(v) {
			this.agencyCodeValid = false;
			this.bannedAgencyCode = false;
			this.findAgency(v);
			if (v) {
				if ((v.length == 3 || v.length == 4 || v.length == 6 || v.length == 9) && v.match(/^[a-z0-9]+$/i)) {
					this.agencyCodeValid = true;
					if (this.agencyCodeBannedList.includes(v)) {
						this.bannedAgencyCode = true;
						return "This PCC has been recognised as a ticketing agency and cannot be accepted. The duo program is not currently available to ticketing agents.";
					} else {
						return true;
					}
				} else {
					return "A valid PCC must be a combination of 3,4,6 or 9 numbers and characters";
				}
			} else {
				return "Enter a valid PCC";
			}
		},
    save() {
      console.log(this.$refs.form.validate())
      console.log(this.agencyCodeHint)
      if (this.$refs.form.validate()) {
        this.formValidationError = false;
        this.registering = true;
        let isValid = this.$refs.form.validate();
        setTimeout(() => {
          if (isValid) {
            axios
              .post("/system/authentication/register", {
                title: this.title,
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                mobileNumber: this.mobileNumber,
                mobileAgent: this.mobileAgent,
                agencyId: this.agencyId,
                agencyCode: this.agencyCode,
                agencyGroupId: this.agencyGroupId,
                agencyName: this.agencyName,
                manualEditAddress: this.manualEditAddress,
                unit: this.unitAgencyAddress,
                street: this.streetAgencyAddress,
                suburb: this.suburbAgencyAddress,
                state: this.stateAgencyAddress,
                postCode: this.postCodeAgencyAddress,
                password: this.password,
                confirmPassword: this.confirmPassword,
                acceptance: true,
                personalAddress: true,
                unitPersonal: this.unitPostalAddress,
                streetPersonal: this.streetPostalAddress,
                suburbPersonal: this.suburbPostalAddress,
                statePersonal: this.statePostalAddress,
                postCodePersonal: this.postCodePostalAddress,
                statePostalAddress: this.statePostalAddress,
              })
              .then(() => {
                this.addDialog = false;
                this.getList();
              })
              .catch((error) => {
                this.$store.commit("showNotification", error.response.data);
                this.addDialog = false;
              });
          } 
        }, 500);
      }
    },
    ruleName(v) {
      if (v) {
        if (v.match(/[^A-Za-z_.-\s]/)) {
          return "Only characters allowed";
        } else {
          return true;
        }
      } else {
        return "Only characters allowed";
      }
		},
    ruleEmail(v) {
			// Allow certain email that ends with asterisk (*) , so need to remove for debouncedCheckEmail
			
      if (v) {
        let isAllowedRegEmail = this.$root.isAllowedRegEmail(v) ? true : false;
        isAllowedRegEmail ? v.slice(0, -1) : v;
        if (isAllowedRegEmail) {
          return true;
        } else if (v.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/)) {
          return true;
        } else {
          return "Please enter a valid email address";
        }
      } else {
        return "Please enter a valid email address";
      }
		},
    closeDialog() {
      this.addDialog = false;
    },
    resendEmail(item) {
      axios
        .post("/system/authentication/registration/resend", { email: item.email })
        .then((response) => {
          if (response.status == 200) {
            this.snackbar = true;
          }
      });
    },
    showImpersonateDialog(item) {
      this.dialogImpersonate.item = item;
      this.dialogImpersonate.show = true;
    },
    onDeletePendingAgent() {
      this.showAgentPendingDialog = true;
    },
    onConfirmChange(item) {
      this.confirmationDialog.item = item;
      let status = this.confirmationDialog.item.status == 'Active' ? 'deactivate this account?' : 'set this account as active?'
      this.confirmationDialog.content = 'Are you sure you want to ' + status + ' <br/> <br/><b>' + item.firstName + ' ' + item.lastName + '<br/>' + item.email + ' ' + '<br/></b>';
      this.confirmationDialog.show = true;
    },
    onCloseConfirmationDialog() {
      this.confirmationDialog.show = false;
      this.confirmationDialog.content = '';
      this.confirmationDialog.item = {};
    },
    changeStatus() {
      let status = this.confirmationDialog.item.status == 'Active' ? 'Inactive' : 'Active'
      axios
        .post("/system/person/status/change", { entity: { id: this.confirmationDialog.item.id, status: status } })
        .then((response) => {
          if (response.status == 200) {
            this.getList();
            this.onCloseConfirmationDialog();
          }
        });
    },
    deletePendingAgents() {
      axios
        .get("/system/person/pending/delete")
        .then((response) => {
          if (response.status == 200) {
            this.showAgentPendingDialog = false;
            this.getList();
            this.snackbarDelete = true;
          }
      });
    },
    getList() {
      axios
        .get("/system/person/info/list")
        .then((response) => {
          this.agentList = response.data;
        })
        .catch(() => { });
    },
    open(item) {
      this.agent = item;
      this.tagList =
        !this.agent.transitMap.tag || this.agent.transitMap.tag.length == 0
          ? [""]
          : this.agent.transitMap.tag;
    },
    addTag() {
      this.tagList.push("");
    },
    removeTag(index) {
      this.tagList.splice(index, 1);
    },
    saveTag(id) {
      for (let idx in this.tagList) {
        if (this.tagList[idx] == "") {
          this.tagList.splice(idx, 1);
        }
      }

      axios
        .post("/system/person/tag/save", { id: id, tag: this.tagList })
        .then(() => {
          this.getList();
        });
    },
    cancel() { },
    close() { },
    getCSVAgent() {
      window.open(axios.defaults.baseURL + "/system/person/agent/info/export");
    },
    getCSVAgentByState() {
      window.open(axios.defaults.baseURL + "/system/person/agent/info/export?filter=state");
    }
  },
};
</script>

<style scoped>
.v-data-table-header th {
  white-space: nowrap;
}

.filter-label {
  font-size: 12px;
  padding-top: 9px;
}</style>